import * as React from "react";
import { useParams } from "react-router";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import { useApolloClient, useQuery } from "@apollo/client";

import { Menu, Footer } from "@pm/gui";

import { Seo } from "../utils/Seo";
import { env } from "../../__config__/env";
import { GlobalStyles } from "../../../client/GlobalStyles";

import { Container } from "../ui/Container";
import { useFadeTransition } from "../utils/hooks/useFadeTransition";
import { Heading } from "../ui/Heading";

import NoMatch from "./NoMatch";

import { GET_PROPERTY_VISNINGSPAAMELDING_QUERY } from "../../../client/__graphql__/queries/getPropertyVisningspaamelding";
import {
  GetPropertyVisningspaamelding,
  GetPropertyVisningspaameldingVariables,
} from "../../__types__/generated/GetPropertyVisningspaamelding";

import { FadeInBackground } from "../ui/FadeInBackground";

import { theme } from "../../../client/theme/thems/nybygg_dark_old";
import { VisningspaameldingFormStandalone } from "../ui/forms/visningspaamelding/Index";

const Visningspaamelding: React.FC = React.memo(() => {
  const params = useParams<{ sguid: string }>();
  const client = useApolloClient();

  const { fadeIn } = useFadeTransition({
    loaded: true,
  });

  const { data, error, loading } = useQuery<
    GetPropertyVisningspaamelding,
    GetPropertyVisningspaameldingVariables
  >(GET_PROPERTY_VISNINGSPAAMELDING_QUERY, {
    fetchPolicy: "network-only",
    variables: {
      input: {
        sguid: params.sguid,
      },
    },
  });

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      window.scroll(0, 0);
    }
  }, []);

  if (error?.graphQLErrors?.length && error.graphQLErrors?.length > 0) {
    if (error.graphQLErrors[0]?.extensions?.code === "404") {
      return <NoMatch />;
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Seo
        title={`Visningspåmelding - PrivatMegleren`}
        description="Påmelding til visning"
      />
      <GlobalStyles />
      <PageGlobalStyles />
      <Menu client={client} config={{ transparent: false, vistopp: false }} />
      <Container style={{ ...fadeIn, paddingTop: "150px" }}>
        <FormWrapper>
          <VisningspaameldingFormStandalone
            data={data}
            graph={env.PM_VISNINGER || ""}
            onSubmit={() => {
              if (typeof window !== "undefined") {
                window.scroll(0, 0);
              }
            }}
          />
        </FormWrapper>
      </Container>
      <Footer />
    </ThemeProvider>
  );
});

export default Visningspaamelding;

const PageGlobalStyles = createGlobalStyle`
  .visningspaamelding-form {
    padding: 20px 20px 60px 20px;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 400px;
  min-height: 100vh;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 300;
    color: #e8c893;
    text-align: center;

    &.address {
      margin-bottom: 0;
    }
    &.title {
    }
  }

  h1.title {
    font-size: 2.5em;
  }

  p {
    color: #fff;
    text-align: center;
  }

  a {
    color: #e8c893;
    text-decoration: none;
  }
`;
